import { Chain, TokenBase } from "~/types";

export enum RankingType {
    Txn = 1,
    Vol = 2,
}

export enum DurationType {
    OneHour = 1,
    SixHour = 2,
    TwelveHour = 3,
    OneDay = 4,
}

export enum TradeMode {
    Buy = 1,
    Sell = 2,
    Swap = 3,
}

export enum ColumnSortType {
    Ascending = 1,
    Descending = 2,
    None = 3,
}

export const RANKING_TYPES = [
    {
        id: RankingType.Vol,
        key: "volume",
    },
    {
        id: RankingType.Txn,
        key: "transaction",
    },
];

export const DURATION_TYPES = [
    {
        id: DurationType.OneHour,
        key: "1h",
    },
    {
        id: DurationType.SixHour,
        key: "6h",
    },
    {
        id: DurationType.TwelveHour,
        key: "12h",
    },
    {
        id: DurationType.OneDay,
        key: "24h",
    },
];

export const DEFAULT_CHAIN: Chain = {
    id: "6000001",
    name: "Solana",
    logo: "https://static.uxuy.me/images/operation/2520a367494-Solana.png",
};

export const DEFAULT_TRADE_TOKEN: TokenBase = {
    add_time: "0",
    chain_id: 1,
    chain_logo: "https://static.uxuy.me/images/chain/color/ethereum.png",
    chain_name: "Ethereum",
    coin_id: "13394237406589761899",
    contract: "0x0000000000000000000000000000000000000000",
    logo: "https://static.uxuy.me/images/token/eth.png",
    native: true,
    symbol: "ETH",
    favorite: false,
};

// 订单状态
export const ORDER_STATUS = {
    COMPLETED: 6, // 成功
    PROGRESS: 1, // 确认中
    FAILED: 9, // 失败
};

// 订单类型
export const ORDER_TYPE = {
    market: 1, // 市价单
    limit: 2, // 限价单
};

// 订单方向
export const ORDER_DIRECTION = {
    buy: 1, // 买入
    sell: 2, // 卖出
    swap: 3, // swap（兑换）
};

// 平台
export const ORDER_PLATFORM = {
    market: 1, //Market Price
    oneClick: 2, // One-click trading
    Limit: 3, // Limit Trading
};

export enum ActionType {
    Buy = "buy",
    Sell = "sell",
}
